(function(angular){
	'use strict';
	
	angular
		.module('emailEntryUnsubscribeModule', [
			'coreModule',
			'formValidationModule'
		])
		.value('globalConfig', globalConfig);

})(window.angular);